<script lang="ts">
  import { Image } from "sveltestrap";
  import UserContent from "./UserContent.svelte";
  let imgPath:string = "/assets/images/user";
  export let getId:string;
</script>

<div
  class="tab-pane fade {getId === 'contact-info-tab' ? 'show active' : ''}"
  id="contact-info-tab"
>
  <div class="user-profile">
    <div class="image">
      <div class="avatar text-center">
        <Image alt="" src="{imgPath}/2.png" />
      </div>
      <div class="icon-wrapper">
        <i class="icofont icofont-pencil-alt-5" />
      </div>
    </div>
    <UserContent />
  </div>
</div>
